module.exports = __webpack_public_path__ + "static/media/editar.c111b2ce.svg";